'use client';
import React from 'react';
import classNames from 'classnames';
import styles from './SimpleHeaderMenu.module.scss';
import { NavigationLogo } from '../../NavigationLogo';
import { LogoVariant } from '@benzinga/logos-ui';
import { faClose } from '@fortawesome/pro-solid-svg-icons/faClose';
import { Icon } from '@benzinga/core-ui';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { MenuInterface } from '../../interfaces';
import { SimpleAccount } from './SimpleAccount';

export const SimpleHeaderMenuListItem: React.FC<MenuInterface> = ({ href, label, subnav }) => {
  const [active, setActive] = React.useState<boolean>(false);

  return (
    <li className={classNames(styles.menuListItem, { active })}>
      <a href={href}>{label}</a>
      {subnav && (
        <div className="ml-auto pl-5 cursor-pointer" onClick={() => setActive(!active)}>
          <Icon className="text-white simple-menu-chevron" icon={faChevronDown} />
        </div>
      )}
      {subnav && (
        <ul className={`sub-menu ${active ? 'sub-menu-active' : ''}`}>
          {subnav?.links.map(item => {
            return (
              <li className="sub-menu-item" key={item.title}>
                <a href={item.href}>{item.label}</a>
              </li>
            );
          })}
        </ul>
      )}
    </li>
  );
};

interface SimpleHeaderMenuProps {
  menus?: MenuInterface[];
  logoVariant?: LogoVariant;
  visible?: boolean;
  onClose?: () => void;
}

export const SimpleHeaderMenu: React.FC<SimpleHeaderMenuProps> = ({ logoVariant, menus, onClose, visible = false }) => {
  const onCloseCallback = () => {
    if (onClose) {
      onClose();
    }
  };

  React.useEffect(() => {
    document.body.style.overflow = visible ? 'hidden' : '';
  }, [visible]);

  return (
    <>
      {visible && <div className="fixed top-0 bottom-0 right-0 left-0 bg-black/50 z-30" onClick={onCloseCallback} />}
      <div className={classNames(styles.menuWrapper, { visible })}>
        <div
          className="bg-zinc-600 text-white absolute top-0 right-0 w-7 h-6 flex items-center justify-center cursor-pointer"
          onClick={onCloseCallback}
        >
          <Icon icon={faClose} />
        </div>
        <div className="px-7 flex justify-center items-center">
          <NavigationLogo deviceType="mobile" logoVariant={logoVariant ?? 'default'} />
        </div>
        <ul className={styles.menuList}>
          {menus?.map(item => {
            return <SimpleHeaderMenuListItem {...item} key={item.title} />;
          })}
        </ul>
        <div className={styles.footerMenu}>
          <SimpleAccount />
        </div>
      </div>
    </>
  );
};
